import config from '../config.json'
import { setError, setSuccess } from './alerts'

declare global {
  interface Array<T> {
    at(index: number): T
  }
}

// eslint-disable-next-line no-extend-native
Array.prototype.at = function (index: number) {
  return this ? this[index] : undefined
}

// export const protocol = `http${ssl ? 's' : ''}://`;
// export const server = `${protocol}${ip}/FrameworkFL/framework/`;

const proxy = '' // 'http://cors-anywhere.herokuapp.com/';
export const server = `${proxy}${config.enderecoBack}`

// export const server = enderecoBack;

export const getCookie = (name: string): string => {
  return document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`))
    ?.split('=')[1] || '';
}

interface headerOptions extends Record<string, string> {
  token: string
  access: string
}

export const headers = (): headerOptions => ({
  token: getCookie('token'),
  access: config.access,
})

interface retornoPadrao {
  status: boolean
  dsErro?: string
}

interface retornoLogin extends retornoPadrao {
  dsEmail?: string
  idUsuario?: number
  nome?: string //! Recebo somente nome
  token?: string
}

export const login = async (
  usuario: string,
  senha: string,
): Promise<retornoLogin> => {
  const res = await fetch(`${server}login.fwfl?idioma=EN`, {
    method: 'POST',
    body: JSON.stringify({ usuario, senha }),
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  return resposta
}

export const register = async (
  dsNome: string,
  dsEmail: string,
  nrDocumento: string,
  dtNascimento: string,
  senha: string,
): Promise<retornoLogin> => {
  const res = await fetch(`${server}nova_conta.fwfl?idioma=EN`, {
    method: 'POST',
    body: JSON.stringify({ dsNome, senha, dsEmail, nrDocumento, dtNascimento }),
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  return resposta
}

export const validaNovaConta = async (
  idUsuario: number,
  cdCodigo: string,
): Promise<retornoLogin> => {
  const res = await fetch(`${server}valida_nova_conta.fwfl?idioma=EN`, {
    method: 'POST',
    body: JSON.stringify({ idUsuario, cdCodigo }),
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  return resposta
}

export const reenviarEmail = async (
  idUsuario: number,
): Promise<retornoLogin> => {
  const res = await fetch(`${server}reenvia_email_conta.fwfl?idioma=EN`, {
    method: 'POST',
    body: JSON.stringify({ idUsuario }),
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  return resposta
}

interface retornoLogout extends retornoPadrao {
  statusLogout?: boolean
}

export const logout = async (): Promise<retornoLogout> => {
  const res = await fetch(`${server}logout.fwfl?idioma=EN`, {
    method: 'POST',
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  return resposta
}

interface retornoAlteraUsuario extends retornoPadrao {
  efetuarNovoLogin?: boolean
  dsMensagem?: string
}

interface alterarUsuarioParams {
  tpTransacao: 'R'
  senhaAtual: string
  senhaNova: string
}

interface alterarUsuarioSenhaParams {
  tpTransacao: 'A'
  dsNome: string
  dsEmail: string
}

export const alterarUsuario = async (
  props: alterarUsuarioParams | alterarUsuarioSenhaParams,
): Promise<retornoAlteraUsuario> => {
  const res = await fetch(`${server}altera_usuario.fwfl?idioma=EN`, {
    method: 'POST',
    body: JSON.stringify(props),
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  return resposta
}

interface retornoRedefinirSenha extends retornoPadrao {
  dsMensagem?: string
}

export const redefinirSenha = async (
  email: string,
): Promise<retornoRedefinirSenha> => {
  const res = await fetch(`${server}esqueci_minha_senha.fwfl?idioma=EN`, {
    method: 'POST',
    body: JSON.stringify({
      href: window.location.href,
      dsEmail: email,
    }),
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  else setSuccess(`Um email de redefinição foi enviado para ${email}`)
  return resposta
}

interface Programa {
  titulo: string
  subtitulo: string
  link: string
  icone: string
  nome: number //! nome é um inteiro???
}

interface retornoProgramasUsuarios extends retornoPadrao {
  list?: Programa[][] //! List é um array de arrays sem necessidade
}

export const programasUsuarios =
  async (): Promise<retornoProgramasUsuarios> => {
    const res = await fetch(`${server}programas_do_usuario.fwfl?idioma=EN`, {
      method: 'POST',
      headers: headers(),
    })
    const resposta = await res.json()
    if (resposta.dsErro) setError(resposta.dsErro)
    return resposta
  }

type retornoNotificacoes = retornoPadrao

export const notificacao = async (
  tipo: 'L' | 'V' = 'L',
  idNotificacao?: number,
): Promise<retornoNotificacoes> => {
  const res = await fetch(`${server}notificacao.fwfl?idioma=EN`, {
    method: 'POST',
    body: JSON.stringify({ tipo, idNotificacao }),
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  return resposta
}

interface DadosPrograma {
  codigo: string
  subtitulo: string
  titulo: string
}

interface retornoDadosPrograma extends retornoPadrao {
  dados?: DadosPrograma
}

export const buscaPrograma = async (
  codigo: string,
): Promise<retornoDadosPrograma> => {
  const res = await fetch(`${server}programa.fwfl?idioma=EN`, {
    method: 'POST',
    body: JSON.stringify({ codigo }),
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  return resposta
}

interface retornoMetodoPrograma
  extends retornoPadrao,
    Record<string, unknown> {}

let programaAberto = ''

export const setProgramaAberto = (codigo: string): void =>
  // eslint-disable-next-line no-void
  void (programaAberto = codigo)

export const metodoPrograma = async (
  metodo: string,
  parametros = {},
  codigo = programaAberto,
): Promise<retornoMetodoPrograma> => {
  const res = await fetch(`${server}acao.fwfl?idioma=EN`, {
    method: 'POST',
    body: JSON.stringify({
      metodo,
      parametros,
      codigo,
    }),
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  return resposta
}

interface retornoAutocomplete extends retornoPadrao {
  result?: [unknown[], string][]
}

export const autoComplete = async (
  metodo: string,
  parametros = {},
  codigo = programaAberto,
): Promise<retornoAutocomplete> => {
  const res = await fetch(`${server}autoComplete.fwfl?idioma=EN`, {
    method: 'POST',
    body: JSON.stringify({
      codigo,
      metodo,
      parametros,
    }),
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  return resposta
}

interface retornoListaPerfis extends retornoPadrao {
  lista?: [
    idUsuario: number,
    idPerfil: number,
    idTipoUsuario: number,
    dsNomePerfil: string,
    snAtivo: boolean,
  ][]
}

export const listaPerfis = async (): Promise<retornoListaPerfis> => {
  const res = await fetch(`${server}lista_perfil_usuario.fwfl?idioma=EN`, {
    method: 'POST',
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  return resposta
}

type retornoselecionaPerfil = retornoPadrao

export const selecionaPerfil = async (
  idUsuario: number,
  idPerfil: number,
  idTipoUsuario: number,
): Promise<retornoselecionaPerfil> => {
  const res = await fetch(`${server}seleciona_perfil_usuario.fwfl?idioma=EN`, {
    method: 'POST',
    body: JSON.stringify({
      idUsuario,
      idPerfil,
      idTipoUsuario,
    }),
    headers: headers(),
  })
  const resposta = await res.json()
  if (resposta.dsErro) setError(resposta.dsErro)
  return resposta
}
